import CalendarView from "../components/CalendarView";

const CalendarPage = () => {
    return (
        <div style={{ padding: "20px" }}>
            <h2>Monthly Planner</h2>
            <CalendarView />
        </div>
    );
};

export default CalendarPage;
